import React from "react";
import logo from "../../Assets/Images/cottonwood-logo.png";
import glooLogo from "../../Assets/Images/gloologo.svg";
import useWindowDimensions from "../../Hooks/useWindowDimensions";

const Header = (props) => {

  const { windowWidth } = useWindowDimensions();

  return (
    <>
      <header>
        <div className="header-wrapper">        
          <div className="logo-left"><img src={logo} alt="Logo" /></div>
          <div className="assessment-title desktop">
            <p className="logo-text">Gloo Tech Check</p>
          </div>
          {windowWidth > 830 ? <div className="logo-right" style={{ }}><img src={glooLogo} width="auto" height={60} alt="Bleat" /></div> : <div className="logo-right"></div>}
        </div>
      </header>
    </>
  )
};

export default Header;
